/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   Current Search Pins constants
 */

export const RECEIVE_PINS = '@@nzr/Pins/RECEIVE_PINS'
export const CLEAR_PINS = '@@nzr/Pins/CLEAR_PINS'
export const START_FETCHING_PINS = '@@nzr/Pins/START_FETCHING_PINS'
export const DONE_FETCHING_PINS = '@@nzr/Pins/DONE_FETCHING_PINS'
